import * as Sentry from '@sentry/react'
import MainButton from 'components/Buttons/MainButton'
import { Container, Title, Message } from './styles'

/**
 * Antes disto o app não tinha nenhum error boundary: qualquer throw durante a renderização
 * derrubava a árvore inteira e o usuário via uma página em branco, sem mensagem e sem nada
 * para clicar. Foi assim que um `.find (...)` sem guarda no modal de reserva apagou a tela
 * do salão.
 *
 * O boundary do Sentry já reporta a exceção junto com o componente que quebrou; quando não
 * há DSN (build local, ver `services/errorReporting.js`) ele só desenha o fallback.
 */
export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback/>}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

export function ErrorFallback() {
  return (
    <Container>
      <Title>Algo deu errado nesta tela</Title>
      <Message>
        O erro foi registrado e a equipe da Cutilei vai olhar.
        Recarregue a página para continuar de onde parou.
      </Message>
      <MainButton
        label='Recarregar a página'
        onClick={() => window.location.reload()}
        width={180}
      />
    </Container>
  )
}
